<template>
  <ct-navbar
    :product="appName"
    breakpoint="is-widescreen"
    :logo-link="{ name: 'home' }">
    <template v-slot:menu>
      <div class="navbar-end">
        <router-link
          v-t="'links.home'"
          :to="{ name: 'home' }"
          class="navbar-item" exact />
        <router-link
          v-if="$auth.check('admin')"
          v-t="'links.settings'"
          :to="{ name: 'settings' }"
          class="navbar-item" />
        <router-link
          v-if="$auth.check('support')"
          v-t="'links.users'"
          :to="{ name: 'users' }"
          class="navbar-item" />
        <router-link
          v-if="!$auth.check(['admin'])"
          v-t="'links.user'"
          :to="{ name: 'my-account' }"
          class="navbar-item" />
        <a href="#" class="navbar-item" @click.prevent="logout()">
          <span class="icon"><i class="fas fa-sign-out-alt"></i></span>
          <span v-t="'links.logout'" />
        </a>
      </div>
    </template>
  </ct-navbar>
</template>

<script>
import Utils from '@/utils'

export default {
  name: 'TheHeader',

  methods: {
    logout () {
      Utils.alertConfirmation(
        this.$t('logout_alert'),
        toast => {
          this.$snotify.remove(toast.id)
          this.$auth.logout({
            redirect: { name: 'login' }
          })
        },
        toast => this.$snotify.remove(toast.id),
        this.$snotify
      )
    }
  },

  computed: {
    appName () {
      return process.env.VUE_APP_NAME
    }
  }
}
</script>

<i18n>
{
  "en-US": {
    "links": {
      "home": "Home",
      "logout": "Log out",
      "settings": "Settings",
      "users": "Customers",
      "user": "My Account"
    },
    "logout_alert": "Do you want to log out?"
  },
  "pt-BR": {
    "links": {
      "home": "Home",
      "logout": "Sair",
      "settings": "Configurações",
      "users": "Clientes",
      "user": "Minha Conta"
    },
    "logout_alert": "Deseja sair do sistema?"
  }
}
</i18n>
